import React from 'react';




const Footer =()=>{

    return(
        <>
  {/* Footer Section Start */}
  <footer className="footer-wrap bg-f pt-4 pb-2 ">
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 ">
          <div className="footer-widget">
            <a href="index.html" className="footer-logo">
              <img
                src="assets/img/resources/logo-white.png"
                alt="Image"
                width={300}
              />
            </a>
            <p className="comp-desc"></p>
            <h5 className="text-white">Technology makes finance easier.</h5>
            Our mission is to gain the trust and confidence of our clients
            through crystal clear communication, reasonable and objective
            guidance, together with a genuine and palpable concern for their
            long term and comprehensive financial growth. <p />
            <p className="comp-desc">
              Email Address :
              <a href="mailto:info@bighitterss.io" className="comp-desc">
                info@metabenz.io
              </a>
            </p>
            <ul className="social-profile list-style style1">
              <li>
                <a target="_blank" href="https://facebook.com">
                  {" "}
                  <i className="flaticon-facebook" />{" "}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://twitter.com">
                  {" "}
                  <i className="flaticon-twitter" />{" "}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://instagram.com">
                  {" "}
                  <i className="flaticon-instagram" />{" "}
                </a>
              </li>
              <li>
                <a target="_blank" href="https://linkedin.com">
                  {" "}
                  <i className="flaticon-linkedin" />{" "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="copyright-text">
        <i className="ri-copyright-line" /> All Rights Reserved By{" "}
        <a href="#" target="_blank">
          Metabenz{" "}
        </a>{" "}
      </p>
    </div>
  </footer>
  {/* Footer Section End */}
</>


    )

}

export default Footer;
